import { debounce } from "lodash";
import { store, setIsMobile } from "../../store/authStore";

const validateIsMobileDevice = (userAgent: string) => {
  // Check initial state
  const checkMobile = () => {
    const isMobileDevice =
      /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(
        userAgent
      );
    const isMobile =
      window.innerWidth <= 768 ||
      (window.innerWidth > 768 && window.innerWidth < 1024);
    store.dispatch(setIsMobile(isMobile || isMobileDevice));
    return isMobile;
  };

  // Debounced resize handler
  const debouncedCheck = debounce(checkMobile, 250);

  // Add resize listener
  window.addEventListener("resize", debouncedCheck);

  // Initial check
  checkMobile();

  // Return cleanup function
  return () => {
    window.removeEventListener("resize", debouncedCheck);
    debouncedCheck.cancel();
  };
};

const validator = {
  validateIsMobileDevice,
};

export default validator;
